import React from "react";

const TitleModal = ({ title, fontSize = "40px", lineHeight = "32px" }) => {
  return (
    <p
      dangerouslySetInnerHTML={{
        __html: title,
      }}
      style={{
        fontSize: fontSize,
        // textTransform: "uppercase",
        fontWeight: "bold",
        overflowWrap: "break-word",
        fontFamily: "Rubik",
        lineHeight: lineHeight,
        color: "#0D0040",
        marginBottom: "20px",
      }}
    />
  );
};

export default TitleModal;
